import { Layers } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { MAP_STYLES, type MapStyle } from "@/lib/map-styles";

interface MapStylePickerProps {
  currentStyle: MapStyle;
  onStyleChange: (style: MapStyle) => void;
  align?: "start" | "end";
  container?: HTMLElement | null;
  buttonVariant?: "outline" | "secondary" | "ghost";
  buttonSize?: "sm" | "icon";
  className?: string;
}

export function MapStylePicker({
  currentStyle,
  onStyleChange,
  align = "start",
  container,
  buttonVariant = "secondary",
  buttonSize = "sm",
  className = "gap-2 shadow-md",
}: MapStylePickerProps) {
  const { t } = useTranslation();

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={buttonVariant} size={buttonSize} className={className}>
          <Layers className="h-4 w-4" />
          {buttonSize !== "icon" && t(currentStyle.labelKey)}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align={align} container={container}>
        {MAP_STYLES.map((style) => (
          <DropdownMenuItem
            key={style.id}
            onClick={() => onStyleChange(style)}
            className={currentStyle.id === style.id ? "bg-accent" : ""}
          >
            {t(style.labelKey)}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
